var _defs, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,22,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,22,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,22,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,22,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,22,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,22,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,22,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,22,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,22,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,22,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,22,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,22,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,22,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,22,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,22,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,22,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,22,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,22,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,22,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,22,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,22,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,22,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,22,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,22,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,22,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,22,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,22,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,26,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,26,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,26,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,26,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,26,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,26,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,26,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,26,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,26,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,26,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,26,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,26,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,26,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,26,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,26,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,26,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,26,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,26,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,26,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,26,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,30,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,30,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,30,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,30,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,30,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,30,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,30,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,30,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,30,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,30,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,30,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,30,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,30,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,30,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,30,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,30,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,30,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,30,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,30,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,30,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,30,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,30,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,30,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,30,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,34,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,34,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,34,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,34,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,34,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,34,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,34,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,34,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,34,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,34,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,34,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,34,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,34,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,34,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,34,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,34,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,34,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,34,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,34,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,38,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,38,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,38,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,38,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,38,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,38,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,38,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,38,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,38,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,38,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,38,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,38,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,38,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,38,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,38,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,38,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,38,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,38,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,38,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,38,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,38,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,38,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,38,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,38,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,38,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,38,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,38,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,38,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,42,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,42,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,42,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,42,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,42,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,42,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,42,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,42,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,42,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,42,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,42,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,42,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,42,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,42,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,42,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,42,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,42,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,42,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,42,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,42,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,42,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,42,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,42,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,42,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,42,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,46,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,46,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,46,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,46,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,46,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,46,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,46,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,46,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,46,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,46,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,46,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,46,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,46,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,46,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,46,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,46,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,46,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,46,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,46,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,46,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,46,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,46,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,46,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,46,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,46,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,50,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,50,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,50,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,50,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,50,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,50,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,50,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,50,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,50,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,50,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,50,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,50,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,50,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,50,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,50,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,50,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,50,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,50,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,50,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,50,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,50,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,50,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,50,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,50,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,50,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,50,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,50,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,54,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,54,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,54,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,54,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,54,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,54,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,54,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,54,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,54,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,54,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,54,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,54,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,54,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,54,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,54,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,54,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,54,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,54,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,54,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,54,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,54,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,54,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,54,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,54,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,54,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,54,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,54,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,54,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,54,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,54,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,54,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,54,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,54,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,54,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,54,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,54,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,54,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,54,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,54,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,54,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,54,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,54,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,54,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,54,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,58,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,58,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,58,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,58,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,58,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,58,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,58,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,58,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,58,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,58,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,58,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,58,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,58,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,58,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,58,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,58,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,58,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,58,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,58,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,58,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,58,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,58,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,58,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,58,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,58,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,58,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,58,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,58,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,58,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,58,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,58,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,62,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,62,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,62,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,62,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,62,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,62,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,62,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,62,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,62,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,62,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,62,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,62,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,62,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,62,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,62,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,62,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,62,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,62,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,62,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,62,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,62,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,62,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,62,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,62,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,62,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,62,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,62,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,62,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,62,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,66,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,66,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,66,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,66,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,66,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,66,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,66,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,66,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,66,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,66,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,66,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,66,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,66,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,66,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,66,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,66,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,66,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,66,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,66,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,66,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,66,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,66,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,66,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,66,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,66,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,66,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,66,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,66,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,66,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,66,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,66,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,66,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,66,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,70,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,70,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,70,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,70,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,70,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,70,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,70,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,70,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,70,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,70,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,70,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,70,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,70,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,70,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,70,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,70,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,70,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,70,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,70,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,70,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,70,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,70,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,70,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,70,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,70,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,70,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,70,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,70,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,70,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,70,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,70,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,70,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,70,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,70,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,70,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,70,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,74,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,74,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,74,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,74,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,74,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,74,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,74,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,74,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,74,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,74,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,74,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,74,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,74,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,74,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,74,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,74,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,74,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,74,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,74,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,74,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,74,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,74,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,74,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,74,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,74,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,74,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,78,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,78,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,78,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,78,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,78,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,78,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,78,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,78,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,78,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,78,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,78,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,78,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,78,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,78,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,78,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,78,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,78,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,78,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,78,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,78,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,78,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,78,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,78,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,78,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,78,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,78,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,78,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,78,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,78,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,78,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,78,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,82,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,82,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,82,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,82,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,82,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,82,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,82,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,82,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,82,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,82,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,82,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,82,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,82,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,82,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,82,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,82,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,82,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,82,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,82,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,82,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,82,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,82,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,82,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,82,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,82,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,82,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,82,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,82,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,82,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,82,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,82,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,82,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,82,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,82,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,86,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,86,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,86,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,86,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,86,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,86,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,86,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,86,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,86,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,86,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,86,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,86,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,86,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,86,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,86,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,86,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,86,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,86,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,86,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,86,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,86,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,86,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,86,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,86,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,86,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,86,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,86,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,86,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,86,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,86,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,86,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,86,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,86,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,86,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,86,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,86,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,90,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,90,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,90,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,90,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,90,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,90,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,90,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,90,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,90,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,90,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,90,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,90,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,90,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,90,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,90,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,90,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,90,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,90,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,90,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,90,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,90,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,90,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,90,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,90,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,90,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,90,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,90,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,90,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,90,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,94,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,94,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,94,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,94,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,94,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,94,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,94,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,94,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,94,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,94,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,94,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,94,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,94,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,94,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,94,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,94,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,94,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,94,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,94,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,94,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,94,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,94,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,94,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,94,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,94,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,94,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,94,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,94,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,94,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,94,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,94,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,94,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,94,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,98,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,98,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,98,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,98,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,98,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,98,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,98,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,98,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,98,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,98,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,98,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,98,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,98,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,98,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,98,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,98,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,98,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,98,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,98,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,98,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,98,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,98,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,98,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,98,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,98,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,98,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,98,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,98,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,98,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,98,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,98,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,98,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,102,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,102,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,102,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,102,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,102,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,102,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,102,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,102,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,102,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,102,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,102,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,102,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,102,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,102,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,102,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,102,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,102,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,102,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,102,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,102,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,102,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,102,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,102,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,102,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,102,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,102,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,102,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,102,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,102,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,102,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,102,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,102,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,102,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,102,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,102,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,102,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,102,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,102,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,106,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,106,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,106,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,106,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,106,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,106,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,106,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,106,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,106,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,106,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,106,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,106,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,106,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,106,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,106,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,106,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,106,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,106,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,106,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,106,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,106,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,106,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,110,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,110,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,110,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,110,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,110,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,110,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,110,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,110,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,110,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,110,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,110,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,110,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,110,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,110,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,110,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,110,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,110,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,110,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,110,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,110,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,110,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,110,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,110,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,110,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,110,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,110,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,110,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,110,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,110,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,110,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,110,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,110,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,110,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,110,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,110,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,110,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,114,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,114,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,114,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,114,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,114,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,114,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,114,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,114,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,114,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,114,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,114,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,114,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,114,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,114,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,114,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,114,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,114,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,114,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,114,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,114,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,114,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,114,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,114,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,114,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,114,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,114,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,114,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,114,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,114,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,114,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,114,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,118,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,118,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,118,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,118,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,118,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,118,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,118,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,118,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,118,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,118,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,118,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,118,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,118,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,118,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,118,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,118,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,118,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,118,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,118,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,118,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,118,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,118,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,118,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,118,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,118,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,118,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,118,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,118,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,118,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,118,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,118,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,118,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,118,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,118,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,118,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,122,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,122,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,122,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,122,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,122,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,122,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,122,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,122,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,122,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,122,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,122,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,122,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,122,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,122,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,122,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,122,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,122,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,122,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,122,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,122,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,122,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,122,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,122,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,122,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,122,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,122,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,126,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,126,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,126,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,126,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,126,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,126,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,126,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,126,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,126,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,126,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,126,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,126,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,126,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,126,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,126,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,126,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,126,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,126,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,126,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,126,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,126,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,126,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,126,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,126,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,126,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,126,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,126,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,126,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,126,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,126,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,126,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,126,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,130,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,130,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,130,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,130,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,130,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,130,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,130,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,130,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,130,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,130,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,130,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,130,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,130,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,130,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,130,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,130,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,130,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,130,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,130,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,130,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,130,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,130,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,130,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,130,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,130,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,130,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,130,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,130,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,130,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,130,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,130,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,130,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,134,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,134,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,134,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,134,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,134,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,134,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,134,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,134,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,134,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,134,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,134,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,134,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,134,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,134,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,134,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,134,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,134,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,134,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,134,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,134,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,134,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,134,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,134,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,134,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,134,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,134,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,134,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,134,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,134,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,134,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,134,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,134,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,134,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,134,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,134,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,134,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,134,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,134,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,138,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,138,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,138,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,138,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,138,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,138,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,138,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,138,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,138,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,138,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,138,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,138,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,138,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,138,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,138,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,138,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,138,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,138,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,138,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,138,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,138,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,138,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,138,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,138,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,138,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,138,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,138,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,138,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,138,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,138,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,142,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,142,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,142,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,142,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,142,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,142,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,142,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,142,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,142,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,142,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,142,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,142,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,142,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,142,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,142,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,142,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,142,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,142,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,142,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,142,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,142,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,142,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,142,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,142,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,142,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,142,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,142,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,142,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,142,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,142,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,142,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,142,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,142,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,142,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,142,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,142,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,142,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,142,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,146,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,146,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,146,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,146,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,146,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,146,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,146,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,146,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,146,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,146,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,146,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,146,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,146,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,146,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,146,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,146,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,146,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,146,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,146,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,146,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,146,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,146,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,146,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,146,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,146,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,146,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,146,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,146,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,146,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,146,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,150,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,150,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,150,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,150,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,150,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,150,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,150,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,150,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,150,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,150,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,150,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,150,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,150,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,150,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,150,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,150,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,150,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,150,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,150,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,150,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,150,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,150,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,150,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,150,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,150,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,150,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,150,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,150,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,150,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,150,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,150,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,150,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,150,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,150,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,150,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,150,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,150,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,150,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,154,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,154,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,154,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,154,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,154,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,154,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,154,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,154,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,154,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,154,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,154,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,154,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,154,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,154,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,154,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,154,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,154,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,154,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,154,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,154,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,154,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,154,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,154,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,154,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,154,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,158,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,158,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,158,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,158,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,158,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,158,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,158,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,158,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,158,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,158,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,158,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,158,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,158,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,158,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,158,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,158,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,158,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,158,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,158,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,158,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,158,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,158,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,158,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,158,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,158,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,158,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,158,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,158,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,158,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,158,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,158,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,158,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,158,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,158,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,158,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,158,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,158,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,158,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,158,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,158,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,162,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,162,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,162,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,162,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,162,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,162,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,162,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,162,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,162,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,162,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,162,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,162,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,162,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,162,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,162,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,162,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,162,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,162,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,162,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,162,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,162,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,162,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,162,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,162,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,162,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,162,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,162,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,162,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,162,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,162,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,162,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,162,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,162,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,162,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,162,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,162,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,162,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,162,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,166,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,166,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,166,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,166,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,166,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,166,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,166,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,166,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,166,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,166,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,166,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,166,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,166,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,166,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,166,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,166,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,166,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,166,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,166,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,166,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,166,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,166,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,166,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,166,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,166,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,166,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,166,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,166,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,166,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,166,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,166,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,166,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,166,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,166,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,166,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,166,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,166,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,170,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,170,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,170,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,170,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,170,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,170,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,170,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,170,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,170,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,170,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,170,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,170,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,170,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,170,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,170,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,170,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,170,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,170,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,170,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,170,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,170,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,170,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,170,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,170,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,170,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,170,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,170,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,170,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,170,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,170,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,170,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,170,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,170,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,170,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,174,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,174,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,174,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,174,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,174,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,174,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,174,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,174,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,174,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,174,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,174,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,174,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,174,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,174,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,174,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,174,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,174,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,174,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,174,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,174,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,174,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,174,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,174,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,174,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,174,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,174,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,174,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,174,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,174,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,174,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,174,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,174,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,174,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,174,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,174,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,178,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,178,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,178,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,178,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,178,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,178,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,178,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,178,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,178,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,178,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,178,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,178,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,178,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,178,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,178,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,178,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,178,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,178,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,178,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,178,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,178,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,178,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,178,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,178,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,178,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,178,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,178,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,178,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,178,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,178,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,178,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,178,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,178,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,182,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,182,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,182,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,182,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,182,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,182,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,182,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,182,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,182,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,182,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,182,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,182,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,182,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,182,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,182,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,182,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,182,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,182,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,182,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,182,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,182,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,182,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,182,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,182,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,182,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,182,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,182,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,182,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,182,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,182,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,182,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,182,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,182,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,182,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,182,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,182,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,182,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,186,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,186,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,186,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,186,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,186,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,186,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,186,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,186,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,186,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,186,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,186,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,186,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,186,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,186,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,186,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,186,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,186,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,186,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,186,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,186,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,186,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,186,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,186,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,186,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,186,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,186,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,186,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,186,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,186,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,186,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,186,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,190,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,190,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,190,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,190,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,190,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,190,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,190,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,190,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,190,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,190,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,190,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,190,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,190,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,190,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,190,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,190,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,190,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,190,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,190,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,190,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,190,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,190,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,190,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,190,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,190,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,190,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,190,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,190,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,190,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,190,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,190,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,190,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,190,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,194,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,194,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,194,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,194,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,194,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,194,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,194,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,194,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,194,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,194,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,194,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,194,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,194,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,194,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,194,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,194,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,194,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,194,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,194,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,194,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,194,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,194,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,194,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,194,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,194,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,194,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,194,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,194,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,194,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,194,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,194,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,194,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,194,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,194,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,194,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,194,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,194,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,194,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,198,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,198,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,198,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,198,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,198,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,198,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,198,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,198,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,198,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,198,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,198,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,198,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,198,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,198,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,198,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,198,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,198,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,198,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,198,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,198,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,198,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,198,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,198,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,198,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,198,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,198,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,198,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,198,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,198,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,198,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,198,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,198,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,198,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,198,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,198,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,198,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,202,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,202,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,202,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,202,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,202,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,202,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,202,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,202,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,202,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,202,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,202,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,202,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,202,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,202,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,202,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,202,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,202,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,202,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,202,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,202,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,202,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,202,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,206,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,206,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,206,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,206,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,206,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,206,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,206,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,206,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,206,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,206,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,206,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,206,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,206,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,206,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,206,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,206,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,206,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,206,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,206,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,206,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,206,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,206,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,206,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,206,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,206,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,206,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,206,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,210,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,210,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,210,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,210,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,210,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,210,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,210,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,210,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,210,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,210,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,210,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,210,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,210,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,210,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,210,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,210,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,210,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,210,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,210,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,210,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,210,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,210,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,210,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,210,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,210,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,210,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,210,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,210,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,210,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,210,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,210,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,210,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,214,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,214,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,214,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,214,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,214,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,214,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,214,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,214,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,214,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,214,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,214,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,214,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,214,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,214,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,214,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,214,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,214,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,214,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,214,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,214,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,214,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,214,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,214,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,214,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,214,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,214,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,214,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,214,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,214,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,214,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,214,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,214,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,214,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,214,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,214,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,214,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,214,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,218,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,218,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,218,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,218,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,218,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,218,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,218,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,218,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,218,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,218,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,218,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,218,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,218,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,218,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,218,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,218,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,218,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,218,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,218,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,218,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,218,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,218,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,218,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,218,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,218,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,218,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,218,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,218,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,218,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,218,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,222,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,222,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,222,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,222,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,222,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,222,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,222,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,222,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,222,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,222,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,222,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,222,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,222,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,222,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,222,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,222,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,222,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,222,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,222,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,222,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,222,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,222,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,222,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,222,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,222,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,222,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,222,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,222,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,222,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,222,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,222,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,222,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,226,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,226,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,226,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,226,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,226,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,226,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,226,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,226,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,226,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,226,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,226,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,226,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,226,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,226,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,226,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,226,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,226,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,226,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,226,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,226,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,226,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,226,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,226,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,226,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,226,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,226,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,226,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,226,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,226,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,226,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,226,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,226,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,230,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,230,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,230,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,230,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,230,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,230,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,230,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,230,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,230,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 76,
    width: 4,
    height: 4,
    transform: "rotate(0,230,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,230,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,230,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,230,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,230,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,230,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,230,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,230,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,230,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,230,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,230,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,230,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,230,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,230,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,230,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,230,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,230,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,230,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,230,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,230,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,230,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,230,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,230,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,234,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,234,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,234,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,234,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,234,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,234,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,234,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,234,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,234,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,234,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,234,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,234,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,234,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,234,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,234,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,234,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,234,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,234,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,234,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,234,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,234,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,234,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,234,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,234,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,234,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,234,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,234,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,234,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,234,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,234,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,234,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,234,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,234,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,234,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,238,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,238,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 40,
    width: 4,
    height: 4,
    transform: "rotate(0,238,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,238,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,238,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,238,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,238,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,238,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,238,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,238,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,238,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,238,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,238,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,238,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,238,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,238,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,238,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,238,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,238,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,238,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,238,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,238,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,238,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,238,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,238,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,238,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 20,
    width: 4,
    height: 4,
    transform: "rotate(0,242,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 32,
    width: 4,
    height: 4,
    transform: "rotate(0,242,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,242,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,242,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,242,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,242,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,242,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,242,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,242,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,242,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,242,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,242,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,242,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,242,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,242,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,242,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,242,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,242,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,242,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,242,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,242,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,242,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,242,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,242,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,242,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 24,
    width: 4,
    height: 4,
    transform: "rotate(0,246,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 28,
    width: 4,
    height: 4,
    transform: "rotate(0,246,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 36,
    width: 4,
    height: 4,
    transform: "rotate(0,246,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 44,
    width: 4,
    height: 4,
    transform: "rotate(0,246,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 48,
    width: 4,
    height: 4,
    transform: "rotate(0,246,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,246,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,246,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,246,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,246,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,246,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,246,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,246,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,246,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,246,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,246,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,246,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,246,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,246,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,246,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,246,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,246,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,246,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,246,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,246,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,246,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,246,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,246,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,246,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,246,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,246,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,246,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,246,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,246,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,246,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,246,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,246,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,246,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,246,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,246,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,246,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,246,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,246,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,246,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,250,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,250,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,250,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,250,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,250,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,250,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,250,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,250,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,250,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,250,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,250,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,250,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,250,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,250,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,250,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,250,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,250,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,250,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,250,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,250,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,250,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,250,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,250,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,250,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,250,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,250,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,250,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,250,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,254,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,254,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,254,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,254,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,254,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,254,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,254,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,254,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,254,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,254,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,254,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,254,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,254,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,254,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,254,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,254,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,254,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,254,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,254,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,254,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,254,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,254,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,254,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,254,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,254,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,258,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,258,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,258,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,258,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,258,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,258,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,258,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,258,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,258,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,258,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,258,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,258,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,258,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,258,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,258,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,258,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,258,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,258,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 200,
    width: 4,
    height: 4,
    transform: "rotate(0,258,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,258,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,258,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,258,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,258,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,258,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,258,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 268,
    width: 4,
    height: 4,
    transform: "rotate(0,258,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,258,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,258,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,262,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,262,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,262,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,262,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,262,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,262,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,262,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,262,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,262,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,262,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,262,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,262,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,262,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,262,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,262,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,262,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,262,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,262,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,262,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,262,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,262,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,262,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,262,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,262,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,262,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,262,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,262,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,262,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,262,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,262,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 248,
    width: 4,
    height: 4,
    transform: "rotate(0,262,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,262,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,262,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,262,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 264,
    width: 4,
    height: 4,
    transform: "rotate(0,262,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,262,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,266,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,266,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,266,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,266,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,266,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,266,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,266,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,266,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,266,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,266,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 160,
    width: 4,
    height: 4,
    transform: "rotate(0,266,162)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,266,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,266,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,266,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,266,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,266,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 204,
    width: 4,
    height: 4,
    transform: "rotate(0,266,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,266,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,266,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,266,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,266,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,266,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,266,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,266,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,266,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,270,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 64,
    width: 4,
    height: 4,
    transform: "rotate(0,270,66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,270,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,270,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 80,
    width: 4,
    height: 4,
    transform: "rotate(0,270,82)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,270,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,270,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,270,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,270,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,270,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,270,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,270,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,270,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 132,
    width: 4,
    height: 4,
    transform: "rotate(0,270,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 140,
    width: 4,
    height: 4,
    transform: "rotate(0,270,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 148,
    width: 4,
    height: 4,
    transform: "rotate(0,270,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,270,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 156,
    width: 4,
    height: 4,
    transform: "rotate(0,270,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,270,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 168,
    width: 4,
    height: 4,
    transform: "rotate(0,270,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 172,
    width: 4,
    height: 4,
    transform: "rotate(0,270,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,270,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,270,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,270,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,270,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,270,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 220,
    width: 4,
    height: 4,
    transform: "rotate(0,270,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 224,
    width: 4,
    height: 4,
    transform: "rotate(0,270,226)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,270,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 232,
    width: 4,
    height: 4,
    transform: "rotate(0,270,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,270,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 252,
    width: 4,
    height: 4,
    transform: "rotate(0,270,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,270,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 276,
    width: 4,
    height: 4,
    transform: "rotate(0,270,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 52,
    width: 4,
    height: 4,
    transform: "rotate(0,274,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 68,
    width: 4,
    height: 4,
    transform: "rotate(0,274,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 72,
    width: 4,
    height: 4,
    transform: "rotate(0,274,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,274,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,274,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 92,
    width: 4,
    height: 4,
    transform: "rotate(0,274,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 96,
    width: 4,
    height: 4,
    transform: "rotate(0,274,98)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,274,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 108,
    width: 4,
    height: 4,
    transform: "rotate(0,274,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 120,
    width: 4,
    height: 4,
    transform: "rotate(0,274,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 124,
    width: 4,
    height: 4,
    transform: "rotate(0,274,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 128,
    width: 4,
    height: 4,
    transform: "rotate(0,274,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,274,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,274,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,274,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 180,
    width: 4,
    height: 4,
    transform: "rotate(0,274,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,274,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 192,
    width: 4,
    height: 4,
    transform: "rotate(0,274,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,274,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,274,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,274,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 228,
    width: 4,
    height: 4,
    transform: "rotate(0,274,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 236,
    width: 4,
    height: 4,
    transform: "rotate(0,274,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 240,
    width: 4,
    height: 4,
    transform: "rotate(0,274,242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 260,
    width: 4,
    height: 4,
    transform: "rotate(0,274,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,274,274)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 56,
    width: 4,
    height: 4,
    transform: "rotate(0,278,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 60,
    width: 4,
    height: 4,
    transform: "rotate(0,278,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 84,
    width: 4,
    height: 4,
    transform: "rotate(0,278,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 88,
    width: 4,
    height: 4,
    transform: "rotate(0,278,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 100,
    width: 4,
    height: 4,
    transform: "rotate(0,278,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 104,
    width: 4,
    height: 4,
    transform: "rotate(0,278,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 112,
    width: 4,
    height: 4,
    transform: "rotate(0,278,114)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 116,
    width: 4,
    height: 4,
    transform: "rotate(0,278,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 136,
    width: 4,
    height: 4,
    transform: "rotate(0,278,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 144,
    width: 4,
    height: 4,
    transform: "rotate(0,278,146)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 152,
    width: 4,
    height: 4,
    transform: "rotate(0,278,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 164,
    width: 4,
    height: 4,
    transform: "rotate(0,278,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 176,
    width: 4,
    height: 4,
    transform: "rotate(0,278,178)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 184,
    width: 4,
    height: 4,
    transform: "rotate(0,278,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 188,
    width: 4,
    height: 4,
    transform: "rotate(0,278,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 196,
    width: 4,
    height: 4,
    transform: "rotate(0,278,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 208,
    width: 4,
    height: 4,
    transform: "rotate(0,278,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 212,
    width: 4,
    height: 4,
    transform: "rotate(0,278,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 216,
    width: 4,
    height: 4,
    transform: "rotate(0,278,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 244,
    width: 4,
    height: 4,
    transform: "rotate(0,278,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 256,
    width: 4,
    height: 4,
    transform: "rotate(0,278,258)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 272,
    width: 4,
    height: 4,
    transform: "rotate(0,278,274)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 20 20v 28h 28v -28zM 24 24h 20v 20h -20z",
    transform: "rotate(0,34,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 12,
    height: 12,
    transform: "rotate(0,34,34)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 252 20v 28h 28v -28zM 256 24h 20v 20h -20z",
    transform: "rotate(90,266,34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 28,
    width: 12,
    height: 12,
    transform: "rotate(90,266,34)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 20 252v 28h 28v -28zM 24 256h 20v 20h -20z",
    transform: "rotate(-90,34,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 260,
    width: 12,
    height: 12,
    transform: "rotate(-90,34,266)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 300,
    width: 300,
    clipPath: "url('#clip-path-background-color')",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    height: 260,
    width: 260,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlain);
export default __webpack_public_path__ + "static/media/plain.0871a2c2f3d771cf87dc053f57d8cdd6.svg";
export { ForwardRef as ReactComponent };